/*
* @Author: Abhi Bhatt
* @Date:   2020-06-24 12:48:45
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-05-06 16:30:13
*/
import axios from 'axios';
import {API_URL} from '../../constants.js';

class ContactService {
	async getMotorDetail(permalink) {
		const url = `${API_URL}/get-motor-details/${permalink}/`;
		const headers = {
			'Content-Type':'multipart/form-data',
			'Access-Control-Allow-Origin':'*'

		}
		let formData = new FormData();
		return axios({
			url:url,
			method: 'get',
			crossDomain:true,
			data: formData,
			config:{headers:headers},
			//headers: {'Access-Control-Allow-Origin': '*'}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async getRep(data) {
		const url = `${API_URL}/get-rep/`;
		const headers = {
			'Content-Type':'multipart/form-data',
			'Access-Control-Allow-Origin':'*'

		}
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			config:{headers:headers},
			data:data
			//headers: {'Access-Control-Allow-Origin': '*'}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}
}

export default ContactService;